import React from "react";

/**
 * Takes text area input with new lines and replaces the new lines with HTML
 * breaking spaces without using `dangerouslySetInnerHTML`.
 *
 * Note: this component applies no text styling and never will. It is only
 * intended to respect manual spaces entered into TextArea inputs.
 *
 * @param {TextAreaOutputProps} props
 */

interface TextAreaOutputProps {
  /**
   * String of text area input to render to HTML
   */
  content: string;
}

export function TextAreaOutput({ content }: TextAreaOutputProps) {
  const renderedComponent = React.useMemo(() => {
    return content.split("\n").map((text, i) => (
      <React.Fragment key={text + i}>
        {i === 0 ? null : <br />}
        {text}
      </React.Fragment>
    ));
  }, [content]);

  return <>{renderedComponent}</>;
}
